<template>
  <div>
    <v-row>
      <v-col cols="4" offset="8" class="text-right">
        <v-text-field
          v-model="search"
          width="150"
          append-icon="mdi-magnify"
          dense
          rounded
          outlined
          hide-details
          placeholder="Search"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :search="search"
          :headers="headers"
          :items="businessProfiles"
          :items-per-page="8"
          @click:row="handleClick"
          class="cursor-pointer"
          item-key="id"
        >
          <template v-slot:item.subscriptionStatus="{ item }">
            <v-chip
              v-if="item.subscriptionStatus"
              label
              :color="
                getStatusColor(item.subscriptionStatus) +
                '--text ' +
                getStatusColor(item.subscriptionStatus) +
                ' lighten-5'
              "
              class="font-weight-medium text-capitalize"
              dark
              small
              >{{ item.subscriptionStatus }}</v-chip
            >
            <v-chip
              v-else
              label
              color="orange--text  orange  lighten-5"
              class="font-weight-medium text-capitalize"
              dark
              small
              >Pending</v-chip
            >
          </template>
          <template v-slot:item.billingPeriod="{ item }">
            <div class="text-capitalize">
              {{ item.billingPeriod ? item.billingPeriod : "-" }}
            </div>
          </template>
          <template v-slot:item.nextInvoiceAmount="{ item }">
            <div>{{ formatCurrency(item.nextInvoiceAmount) }}</div>
          </template>
          <template v-slot:item.businessCardsIssued="{ item }">
            <div>{{ getNumberOfBusinessCardsIssued(item.id) }}</div>
          </template>

          <template v-slot:item.pendingCards="{ item }">
            <div>{{ getNumberOfPendingCards(item.id) }}</div>
          </template>

          <template v-slot:item.businessCategory="{ item }">
            <div v-if="item.businessCategory">{{ item.businessCategory }}</div>
            <div v-else>-</div>
          </template>
          <template v-slot:item.noOfEmployees="{ item }">
            <div>{{ item.noOfEmployees ? item.noOfEmployees : 1 }}</div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <BusinessProfileDetails
      v-if="businessProfile != null"
      :show="showDialog"
      :cardholders="cardholders"
      :businessProfiles="businessProfiles"
      :users="users"
      @close="showDialog = false"
      :businessProfileId="businessProfile.id"
      :businessPortalAccess="businessPortalAccess"
    />
  </div>
</template>

<script>

import UserAvatar from "@/components/UserAvatar";
import * as currency from "currency.js";
import IconContainer from "@/components/IconContainer";
import BusinessProfileDetails from "@/components/SuperUser/BusinessProfileDetails";

export default {
  components: {
    UserAvatar,
    IconContainer,
    BusinessProfileDetails,
  },
  props: {
    businessPortalAccess: {
      type: Array,
      default: function () {
        return [];
      },
    },
    cardholders: {
      type: Array,
      default: function () {
        return [];
      },
    },
    users: {
      type: Array,
      default: function () {
        return [];
      },
    },
    businessProfiles: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Business Name",
          align: "left",
          value: "businessName",
        },
        {
          text: "Team Size",
          align: "left",
          value: "noOfEmployees",
        },
        {
          text: "Cards Issued",
          align: "left",
          value: "businessCardsIssued",
        },
        {
          text: "Pending Cards",
          align: "left",
          value: "pendingCards",
        },
        {
          text: "Category",
          align: "left",
          value: "businessCategory",
        },

        {
          text: "Subscription Status",
          align: "left",
          value: "subscriptionStatus",
        },
        {
          text: "Amount",
          align: "left",
          value: "nextInvoiceAmount",
        },
        {
          text: "Billing Period",
          align: "left",
          value: "billingPeriod",
        },
      ],
      search: "",
      businessProfile: null,
      showDialog: false,
      tab: 0,
      businessCardHeaders: [
        {
          text: "",
          align: "right",
          value: "avatar",
          sortable: false,
        },
        {
          text: "First Name",
          align: "left",
          value: "firstName",
        },
        {
          text: "Last Name",
          align: "left",
          value: "lastName",
        },
        {
          text: "Email",
          align: "left",
          value: "email",
        },
        {
          text: "Business Name",
          align: "left",
          value: "businessName",
        },
        {
          text: "Job Title",
          align: "left",
          value: "jobTitle",
        },
        {
          text: "Subscription type",
          align: "left",
          value: "subscriptionType",
        },
        {
          text: "Status",
          align: "left",
          value: "status",
        },
      ],
      associatedUsersHeaders: [
        {
          text: "First Name",
          align: "left",
          value: "firstName",
        },
        {
          text: "Last Name",
          align: "left",
          value: "lastName",
        },
        {
          text: "Email",
          align: "left",
          value: "email",
        },
        // {
        //   text: "User type",
        //   align: "left",
        //   value: "userType",
        // },
      ],
    };
  },
  computed: {
    businessCards() {
      let businessCards = this.cardholders.filter((cardholder) => {
        return cardholder.businessProfileId == this.businessProfile.id;
      });
      return businessCards;
    },
    associatedUsers() {
      let associatedUsers = this.users.filter((user) => {
        return user.businessProfileId == this.businessProfile.id;
      });
      return associatedUsers;
    },
  },
  methods: {
    getNoOfBusinessProfiles(email) {
      let usersBusinessProfiles = this.businessPortalAccess.filter((item) => {
        return item.email == email;
      });
      return usersBusinessProfiles.length;
    },
    getStatusColor(status) {
      if (status) {
        if (
          status.toLowerCase() == "active" ||
          status.toLowerCase() == "trialing"
        )
          return "green";
        else if (status.toLowerCase() == "pending") return "orange";
        else if (status.toLowerCase() == "declined") return "red";
        else return "red";
      }
    },
    formatCurrency(nextInvoiceAmount) {
      return currency(nextInvoiceAmount, {
        fromCents: true,
        separator: ",",
      }).format();
    },
    getNumberOfBusinessCardsIssued(businessProfileId) {
      let numberOfBusinessCardsIssued = this.cardholders.filter(
        (cardholder) => {
          return (
            cardholder.businessProfileId == businessProfileId &&
            (cardholder.status == "Active" || cardholder.status == "Pending")
          );
        }
      );
      return numberOfBusinessCardsIssued.length;
    },
    handleClick(businessProfile) {
      this.businessProfile = businessProfile;
      this.showDialog = true;
    },
    getNumberOfPendingCards(businessProfileId) {
      let numberOfPendingBusinessCards = this.cardholders.filter(
        (cardholder) => {
          return (
            cardholder.businessProfileId == businessProfileId &&
            cardholder.status == "Pending"
          );
        }
      );
      return numberOfPendingBusinessCards.length;
    },
  },
};
</script>

<style></style>
